<template>
  <v-card>
    <v-snackbar
      :value="submitError"
      :timeout="3000"
      color="error"
      class="ma-0"
      dark
      top
    >
      <span class="body-2">{{ submitErrorMsg }}</span>
    </v-snackbar>
    <v-card-text class="py-0">
      <v-dialog
        v-model="dialog"
        max-width="350"
        @click:outside="handleCancelDialog"
      >
        <v-card>
          <DialogBaseColoredTitle color="primary">{{
            $cmsService.getContent(content, 'time_checkbox')
          }}</DialogBaseColoredTitle>
          <v-divider></v-divider>
          <DialogBaseText class="text-center">
            <v-time-picker
              v-model="timeSelect"
              :allowed-minutes="allowedStep"
              format="24hr"
            ></v-time-picker>
          </DialogBaseText>
          <v-divider></v-divider>
          <DialogBaseActions>
            <v-btn color="secondary" @click="handleCancelDialog"
              >Abbrechen</v-btn
            >
            <v-spacer />
            <v-btn :disabled="!timeSelect" color="primary" @click="submit">{{
              $cmsService.getContent(content, 'submit')
            }}</v-btn></DialogBaseActions
          >
        </v-card>
      </v-dialog>
      <v-row align="center">
        <v-col cols="auto" class="pr-0">
          <v-checkbox
            v-model="isActive"
            hide-details
            class="shrink mr-2 mt-0"
            @change="toggleActive"
          ></v-checkbox>
        </v-col>
        <v-col cols="auto" class="pl-0">
          <v-text-field
            readonly
            :value="selectedTime"
            :disabled="!isActive"
            :label="$cmsService.getContent(content, 'time_checkbox')"
            hide-details
            @click="openDialog()"
          >
            <template v-if="selectedTime" #append>
              <v-btn icon @click="deleteTime">
                <v-icon color="error">mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { planningService } from '@/services/'
import timePickerJson from '@/data/json/timePicker.json'

export default {
  data: () => ({
    content: timePickerJson.data,
    timeSelect: '',
    isActive: false,
    submitError: false,
    submitErrorMsg: '',
    selectedTime: '',
    dialog: false
  }),
  created: function () {
    this.getAutoCompleteTime()
  },
  methods: {
    allowedStep: m => m % 30 === 0,
    openDialog() {
      this.dialog = true
    },
    toggleActive(event) {
      if (event) {
        if (!this.selectedTime) {
          this.dialog = true
        }
        // active = false
      } else {
        this.deleteTime()
      }
    },
    handleCancelDialog() {
      this.dialog = false
      if (!this.selectedTime) this.isActive = false
    },
    submit() {
      this.submitError = false
      let date = new Date()
      const timeSplit = this.timeSelect.split(':')
      date.setHours(timeSplit[0])
      date.setMinutes(timeSplit[1])
      return planningService
        .setProductionTime({
          isActive: this.isActive,
          autoCompletionDate: this.momentDate(date)
        })
        .then(response => {
          this.setSelectedTime(response.autoCompletionDate)
        })
        .catch(() => {
          this.submitError = true
          this.submitErrorMsg = this.$cmsService.getContent(
            this.content,
            'submit_error'
          )
          this.isActive = false
        })
        .finally(() => {
          this.dialog = false
        })
    },
    setSelectedTime(date) {
      if (!date) {
        this.selectedTime = ''
        this.timeSelect = ''
      } else {
        this.selectedTime = this.momentDate(date).format('HH:mm')
        this.timeSelect = this.selectedTime
      }
    },
    getAutoCompleteTime() {
      planningService.getProductionTime().then(response => {
        this.setSelectedTime(response.autoCompletionDate)
        this.isActive = response.isActive
      })
    },
    deleteTime() {
      return planningService
        .setProductionTime({
          isActive: false
        })
        .then(response => {
          this.setSelectedTime(response.autoCompletionDate)
          this.isActive = response.isActive
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped></style>
